export default {

    topic: null,
    isCategoryTopic: false,
    topicsModel: false,

    subtopics: [],

    item: null,

    clickedReferences: [],
    itemContent: null,

    topicsNews: {
        'Algoritmos': {
            model: true,
            text: null
        },
        'Doenças': {
            model: true,
            text: null
        }
    }

}